var map = {
	"./main-1.png": "697c",
	"./main-1_active.png": "b87d",
	"./main-2.png": "853e",
	"./main-2_active.png": "be1d",
	"./main-3.png": "0ebd",
	"./main-3_active.png": "d707",
	"./main-4.png": "bd6a",
	"./main-4_active.png": "4e1c",
	"./main-5.png": "f3b6",
	"./main-5_active.png": "f8ce",
	"./main-6.png": "26e8a",
	"./main-6_active.png": "a551",
	"./main-active.png": "72b6"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) { // check for number or string
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return id;
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "8ef9";